import { Box, Collapse, IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { FileIcon } from "lucide-react";
import { MediaUrl } from "../../../utils/configuration";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";

const StationFiles = ({ data, editUrl, defaultOpen }: { data: any[]; editUrl: string; defaultOpen?: boolean }) => {
    const [open, setOpen] = useState<boolean>(defaultOpen || false);
    return (
        <div className="bg-white rounded-md">
            <Box sx={{ borderRadius: 1, border: "1px solid #cce4ff" }}>
                <Box
                    className="summary_header"
                    sx={{
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                    onClick={() => setOpen(!open)}
                >
                    <Typography fontWeight="bold">Tài liệu</Typography>
                    <div className="flex items-center gap-2">
                        <Link
                            to={editUrl}
                            className="flex items-center gap-1 italic text-blue-500 text-sm hover:underline"
                        >
                            <Pencil size={12} />
                            Sửa
                        </Link>
                        <IconButton size="small">
                            <ExpandMoreIcon
                                sx={{
                                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.2s",
                                }}
                            />
                        </IconButton>
                    </div>
                </Box>
                <Collapse in={open}>
                    <Box className="summary_content flex flex-col gap-2" sx={{ p: 2 }}>
                        {data.length > 0 ? data.map((attachment, index) => (
                            <div key={index} className="flex items-center gap-2">
                                <a href={MediaUrl + attachment.path} target="_blank" rel="noopener noreferrer" className="bg-gray-100 flex justify-center items-center gap-2 p-2">
                                    <FileIcon size={16} />
                                    <p>{attachment.fileName}</p>
                                </a>
                            </div>
                        )) : (
                            <p className="text-center">Không có tài liệu</p>
                        )}
                    </Box>
                </Collapse>
            </Box>
        </div>
    );
};

export default StationFiles;